import { Font } from '@pdfme/common';

export const getFont = async () => {
  const mincho = await fetch('/yumin.ttf').then(res => res.arrayBuffer());
  const font = { mincho: { data: mincho, subset: true, fallback: true } };
  return font;
};

export const getFontsForInvoice = async () => {
  const mincho = await fetch('/yumin.ttf').then(res => res.arrayBuffer());
  const minchoBold = await fetch('/yumindb.ttf').then(res => res.arrayBuffer());

  const fonts = {
    mincho: { data: mincho, subset: true, fallback: true },
    minchoBold: { data: minchoBold, subset: true }
  };

  return fonts;
};

export const getFontsForReceipt = async (): Promise<Font> => {
  const mincho = await fetch('/yumin.ttf').then(res => res.arrayBuffer());
  const minchoBold = await fetch('/yumindb.ttf').then(res => res.arrayBuffer());

  const fonts: Font = {
    mincho: { data: mincho, subset: true, fallback: true },
    minchoBold: { data: minchoBold, subset: true }
  };

  return fonts;
};
